import { useEffect, useState } from 'react';

import { Button, notification } from 'antd';

import Section from 'layouts/Section/Section';

import JobCard from 'components/Job/JobCard/JobCard';
import ResponsiveCarousel from 'components/ResponsiveCarousel/ResponsiveCarousel';
import Title from 'components/Title/Title';

import generateParams from 'utils/generateParams';
import Services from 'utils/services';

import { SortOrders } from 'types/api';
import { Job } from 'types/jobs';

import { SORT_BY_EDIT_DATE } from 'constants/commons';
import { JOIN_URL } from 'constants/endpoints';

import { ReactComponent as ArrowRight } from 'assets/icons/arrowRight.svg';

import styles from './styles.module.scss';

const JobsCarousel = () => {
  const [jobsData, setJobsData] = useState<Job[] | null>(null);

  useEffect(() => {
    const fetchJob = async () => {
      const params = generateParams({
        pageSize: 21,
        sortField: SORT_BY_EDIT_DATE,
        order: SortOrders.Desc
      });

      try {
        const jobs = await Services.getJobs(params);
        setJobsData(jobs);
      } catch {
        notification.error({
          message: 'Error loading job details',
          placement: 'topRight',
          duration: 5
        });
      }
    };

    fetchJob();
  }, []);

  return (
    <Section
      className={styles.jobCarouselContainer}
      background="--brand-primary-lighten"
    >
      <Title title="Browse Jobs and Apply" />
      {jobsData && (
        <ResponsiveCarousel
          responsive={[
            { breakpoint: 1220, settings: { slidesToShow: 3 } },
            {
              breakpoint: 860,
              settings: { slidesToShow: 2, centerMode: false }
            },
            {
              breakpoint: 630,
              settings: { slidesToShow: 1, centerMode: false }
            }
          ]}
          slidesToShow={4}
          centerMode={true}
          className={styles.carouselContainer}
          adaptiveHeight={false}
        >
          {jobsData.map((job: Job) => (
            <JobCard job={job} key={job.id} />
          ))}
        </ResponsiveCarousel>
      )}
      <Button
        className={styles.submitButton}
        type="link"
        icon={<ArrowRight />}
        iconPosition="end"
        href={`${JOIN_URL}/jobs`}
        target="_blank"
        rel="noopener noreferrer"
      >
        Browse More Jobs
      </Button>
    </Section>
  );
};

export default JobsCarousel;
